import {
  Component,
  ChangeDetectionStrategy,
  OnInit,
  Type,
} from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import {
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyModule,
} from '@ngx-formly/core';
import { FieldType, FormlyFieldProps } from '@ngx-formly/material/form-field';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { FieldMaskDirective } from './field-mask.directive';
import { MatInputModule } from '@angular/material/input';

import { NgxMaskDirective, provideNgxMask} from 'ngx-mask';

interface InputProps extends FormlyFieldProps {
  fieldMask;
}

export interface FormlyInputFieldConfig extends FormlyFieldConfig<InputProps> {
  type: 'input' | Type<InputComponent>;
}

export const normalizePhoneInputValue = (value: unknown) => {
  if (value === null || value === undefined || value === '') {
    return value;
  }

  return value.toString().replace(/\D/g, '');
};

@Component({
  selector: 'itc-formly-field-mat-input',
  template: `
  @switch (type) {
    @case ("hidden") {
      <input
        [id]="id"
        type="hidden"
        [formControl]="control"
        [formlyAttributes]="field"
      />
    }
    @case ("phone") {
      <input
        matInput
        [readonly]="props.readonly"
        [required]="props.required"
        [formControl]="control"
        [placeholder]="props.placeholder"
        mask="(000) 000-0000"
      />
    }
    @case("currency"){
      <input
        matInput
        [id]="id"
        type="currency"
        [readonly]="props.readonly"
        [required]="props.required"
        [formControl]="control"
        [formlyAttributes]="field"
        [tabIndex]="props.tabindex"
        [placeholder]="props.placeholder"
        mask="separator.0"
        thousandSeparator=","
      />
    }
    @case("number"){
      <input
        matInput
        [id]="id"
        type="number"
        [readonly]="props.readonly"
        [required]="props.required"
        [errorStateMatcher]="errorStateMatcher"
        [formControl]="control"
        [formlyAttributes]="field"
        [tabIndex]="props.tabindex"
        [placeholder]="props.placeholder"
      />
    }
    @default{
      <input
        matInput
        [id]="id"
        [type]="type || 'text'"
        [readonly]="props.readonly"
        [required]="props.required"
        [errorStateMatcher]="errorStateMatcher"
        [formControl]="control"
        [formlyAttributes]="field"
        [tabIndex]="props.tabindex"
        [placeholder]="props.placeholder"
        itcMask
        [isMaskEnabled]="props.fieldMask"
      />
    }
  }`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FieldMaskDirective,
    FormlyModule,
    ReactiveFormsModule,
    MatInputModule,
    NgxMaskDirective
],
  providers: [provideNgxMask()],

})
export class InputComponent
  extends FieldType<FieldTypeConfig<InputProps>>
  implements OnInit
{
  get type() {
    return this.props.type || 'text';
  }
  control: UntypedFormControl;
  override defaultOptions = {
    props: {
      appearance: 'fill' as MatFormFieldAppearance,
      fieldMask: false,
    },
  };

  ngOnInit() {
    this.control = this?.formControl as UntypedFormControl;

    if (this.type === 'phone') {
      const normalizedValue = normalizePhoneInputValue(this.control.value);
      if (normalizedValue !== this.control.value) {
        this.control.setValue(normalizedValue, { emitEvent: false });
      }
    }
  }
}
